import type { SelectSelection, SelectComplexItem } from '@circlek-global/lds-components';

export const isSelectComplexItem = (selectItem: SelectSelection): selectItem is SelectComplexItem => {
  if (selectItem === null) return false;
  if (Array.isArray(selectItem)) return false;
  if (typeof selectItem === 'string' || typeof selectItem === 'number') return false;

  return 'id' in selectItem;
};
